import React, { createContext, useContext } from 'react';

const OverlayContext = createContext(null);

export const useOverlay = () => {
  return useContext(OverlayContext);
};

export const OverlayProvider = ({ children, showOverlay, hideOverlay }) => {
  return (
    <OverlayContext.Provider value={{ showOverlay, hideOverlay }}>
      {children}
    </OverlayContext.Provider>
  );
};


